export default __webpack_public_path__ + "static/media/Picture2.72469fcd.png";